import {
  EMAIL_VERIFICATION_ERROR_TYPES,
  EMAIL_VERIFICATION_STATUSES,
  EMAIL_VERIFICATION_STEPS,
  type EmailVerificationErrorType,
  type EmailVerificationStatus,
  type EmailVerificationStep,
} from "./types";

export const isUserNotFound = (status: EmailVerificationStatus | null) =>
  status === EMAIL_VERIFICATION_STATUSES.user_not_found;

export const isExistingMember = (status: EmailVerificationStatus | null) =>
  status === EMAIL_VERIFICATION_STATUSES.existing_member;

export const isNewMember = (status: EmailVerificationStatus | null) =>
  status === EMAIL_VERIFICATION_STATUSES.new_member;

export const isUserWithPendingInvitation = (
  status: EmailVerificationStatus | null,
) => status === EMAIL_VERIFICATION_STATUSES.user_with_pending_invitation;

export const isInitialStep = (step: EmailVerificationStep | null) =>
  step === EMAIL_VERIFICATION_STEPS.initial;

export const isValidatingStep = (step: EmailVerificationStep | null) =>
  step === EMAIL_VERIFICATION_STEPS.validating;

export const isOTPRequiredStep = (step: EmailVerificationStep | null) =>
  step === EMAIL_VERIFICATION_STEPS.otp_required;

export const isPasswordSigninStep = (step: EmailVerificationStep | null) =>
  step === EMAIL_VERIFICATION_STEPS.password_signin;

export const isSignupStep = (step: EmailVerificationStep | null) =>
  step === EMAIL_VERIFICATION_STEPS.signup;

export const isClaimStep = (step: EmailVerificationStep | null) =>
  step === EMAIL_VERIFICATION_STEPS.claim;

export const isManualEmailError = (
  errorType: EmailVerificationErrorType | null,
) => errorType === EMAIL_VERIFICATION_ERROR_TYPES.manual;
